"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toast = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const ToastPrimitive = require("@radix-ui/react-toast");
const classNames_1 = require("../../../../../utils/classNames");
const toast_action_1 = require("./toast-action");
const toast_close_1 = require("./toast-close");
const toast_description_1 = require("./toast-description");
const toast_title_1 = require("./toast-title");
const toast_viewport_1 = require("./toast-viewport");
const toaster_1 = require("./toaster");
const ToastForwarded = (0, react_1.forwardRef)(({ className, ...props }, ref) => ((0, jsx_runtime_1.jsx)(ToastPrimitive.Root, { ref: ref, className: (0, classNames_1.cn)('aries-toast data-[state=open]:animate-in data-[state=closed]:animate-out data-[swipe=end]:animate-out data-[state=closed]:fade-out-80 data-[state=open]:slide-in-from-top-full data-[state=open]:sm:slide-in-from-bottom-full data-[state=closed]:slide-out-to-right-full bg-background group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border border-[#B7002A] bg-[#FFF0F4] py-2.5 px-5 shadow-lg transition-all data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=cancel]:translate-x-0 data-[swipe=end]:translate-x-[var(--radix-toast-swipe-end-x)] data-[swipe=move]:transition-none', className), ...props })));
exports.Toast = {
    ...ToastForwarded,
    Provider: ToastPrimitive.Provider,
    Viewport: toast_viewport_1.ToastViewport,
    Title: toast_title_1.ToastTitle,
    Description: toast_description_1.ToastDescription,
    Close: toast_close_1.ToastClose,
    Action: toast_action_1.ToastAction,
    Toaster: toaster_1.Toaster,
};
